import { useQuery } from "@tanstack/react-query";
import api from "../../../../../util/api";
import { QueryKeys } from "../../../../../util/types";
import {
  EMPTY_PRICE_CATALOGUE_FILTERS,
  type PriceCatalogueFilters,
  type PriceCatalogueProfile,
} from "../types";

const EMPTY_PROFILES: PriceCatalogueProfile[] = [];

export const useGetPriceCatalogue = (
  filters: PriceCatalogueFilters = EMPTY_PRICE_CATALOGUE_FILTERS
) => {
  const { data, isLoading, error, refetch } = useQuery<PriceCatalogueProfile[]>(
    {
      queryKey: [
        QueryKeys.LIST_PRICE_CATALOGUE,
        filters.subscriptionOption ?? "",
        filters.subscriptionLevel ?? "",
        filters.billingCurrency ?? "",
        filters.interval ?? "",
      ],
      queryFn: async () => {
        const params = new URLSearchParams();
        if (filters.subscriptionOption) {
          params.set("subscriptionOption", filters.subscriptionOption);
        }
        if (filters.subscriptionLevel) {
          params.set("subscriptionLevel", filters.subscriptionLevel);
        }
        if (filters.billingCurrency) {
          params.set("billingCurrency", filters.billingCurrency);
        }
        if (filters.interval) {
          params.set("interval", filters.interval);
        }
        const query = params.toString();
        const res = await api.get(
          `/billing/price-catalogue${query ? `?${query}` : ""}`
        );
        return Array.isArray(res?.data) ? res.data : [];
      },
    }
  );

  return {
    profiles: error ? EMPTY_PROFILES : data ?? EMPTY_PROFILES,
    loading: isLoading,
    error: error
      ? error instanceof Error
        ? error.message
        : "Failed to load price catalogue"
      : null,
    refresh: () => {
      refetch();
    },
  };
};
